import { render } from "./Index.vue?vue&type=template&id=15992790"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script